import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useContent } from '../context/ContentContext';
import { getPageSEO, serializeJSON } from '../lib/seo';

export function usePageSEO() {
  const { pathname } = useLocation();
  const { content, settings, pages } = useContent();
  useEffect(() => {
    const seo = getPageSEO(pathname, content, settings, pages);
    document.title = seo.title;
    for (const [key, value] of Object.entries(seo.meta)) {
      const attribute = key.startsWith('og:') ? 'property' : 'name';
      let element = document.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
      }
      element.content = value;
    }
    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = seo.canonical;
    let jsonLd = document.getElementById('page-jsonld') as HTMLScriptElement | null;
    if (!jsonLd) {
      jsonLd = document.createElement('script');
      jsonLd.type = 'application/ld+json';
      jsonLd.id = 'page-jsonld';
      document.head.appendChild(jsonLd);
    }
    jsonLd.textContent = serializeJSON(seo.jsonLd);
  }, [pathname, content, settings, pages]);
}
